import assign from 'lodash/assign';
import ModalConstants from 'app/shared/constants/ModalConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    header: '',
    isOpen: false,
    modalType: '',
    onClose: () => {},
    onOpen: () => {},
    shouldCloseOnOverlayClick: true,
    shouldReloadOnLoginSuccess: true,
    modalAddProperty: {
        behavior: 'Add',
        isOpen: false,
    },
    modalImageCarousel: {
        isOpen: false,
    },
});

const modal = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.MODAL_SHOW:
            return { ...initState(), ...payload, isOpen: true };
        case DispatchConstants.MODAL_UPDATE:
            return { ...state, ...payload };
        case DispatchConstants.MODAL_HIDE:
            return initState();

        // TODO: clean up
        case ModalConstants.MODAL_ADD_PROPERTY_UPDATE_DISPLAY: {
            return assign({}, state, {
                ...state,
                modalAddProperty: {
                    ...state.modalAddProperty,
                    isOpen: payload.isOpen,
                    behavior: payload.behavior,
                },
            });
        }

        case ModalConstants.MODAL_IMAGE_CAROUSEL_UPDATE_DISPLAY:
            return assign({}, state, { modalImageCarousel: payload });

        case ModalConstants.SHOULD_RELOAD_ON_LOGIN_SUCCESS:
            return assign({}, state, { shouldReloadOnLoginSuccess: payload });

        default:
            return state;
    }
};

export default modal;
